export default __webpack_public_path__ + "static/media/En_cotización.6c01f1b5.svg";